import { formatDistanceToNow as _formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns';

import { locales } from '../constants/locales';
import { InTimeZone, TimeFormat } from '../types';

export const formatDistanceToNow = (
  dateInput: string | Date,
  addSuffix: boolean = true,
  options: {
    locale: keyof typeof locales;
    timeZone?: InTimeZone;
    timeFormat?: TimeFormat;
    strict?: boolean;
  } = {
    locale: 'en',
    timeZone: undefined,
    timeFormat: undefined,
    strict: true,
  }
): string => {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return '';
  const format = (options.strict ?? true) ? formatDistanceToNowStrict : _formatDistanceToNow;

  return format(date, {
    locale:
      locales[
        options.timeFormat === 'TWELVE' && options.locale === 'en'
          ? 'enUS' // add support for 12 hours format (AM/PM)
          : options.locale
      ],
    in: options.timeZone,
    addSuffix,
  });
};
